import Marquee from "react-fast-marquee";

const PHRASES = ["Every song is a confession", "Every oath has a cost"];

export const MarqueeRibbon = () => {
  return (
    <section
      data-testid="marquee-ribbon"
      className="relative border-y border-white/10 bg-[#0a0a0a] py-6"
      aria-hidden="true"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {PHRASES.map((phrase, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-word px-8 text-lg uppercase text-[#e8e3d2]/80 sm:text-2xl">
              {phrase}
            </span>
            <span className="text-xl text-[#c9a227]">&#10022;</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default MarqueeRibbon;
